<template>
  <md-card v-if="data">
    <md-card-content>
      <md-table
        class="no-will-change max-w-100"
        v-fixedTableHeader:computed-table-header
      >
        <target-table-data-header :filters="activeFilters">
          <template v-slot:headers>
            <slot
              name="headers"
              v-bind="{ data: data, filters: activeFilters }"
            ></slot>
          </template>
        </target-table-data-header>

        <component
          :is="getTableTypePerAggregationType()"
          :rows="queriedData"
          :filters="activeFilters"
          v-slot="{ row }"
        >
          <md-table-cell
            class="border-right"
            v-for="(column, index) in row.columns"
            :key="index"
          >
            <computed-table-cell
              v-model="column.value"
              :attrs="getCellAttrs(activeFilters)"
              :units="units"
            ></computed-table-cell>
          </md-table-cell>
        </component>
      </md-table>
    </md-card-content>
    <md-card-actions>
      <pagination
        v-if="pagination.perPage < total"
        class="pagination-no-border pagination-primary right"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </pagination>
      <md-button class="md-success" @click="save">Save</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import TargetTableDataHeader from "./ComputedTableHeader.vue";
import TargetTableDataPerDay from "./ComputedTableDataPerDay.vue";
import TargetTableDataPerSeasonAndDemand from "./ComputedTableDataPerSeasonAndDemand.vue";
import ComputedTableCell from "./ComputedTableCell.vue";

import Pagination from "@/components/Pagination";
import PaginationMixins from "@/components/PaginationMixins";

export default {
  name: "TargetTableData",
  mixins: [PaginationMixins],
  components: {
    TargetTableDataHeader,
    TargetTableDataPerDay,
    TargetTableDataPerSeasonAndDemand,
    ComputedTableCell,
    Pagination
  },
  props: {
    endpoints: Object,
    getCellAttrs: Function,
    units: [Object, String],
    paginationEnabled: Boolean
  },
  data() {
    return {
      activeFilters: null,
      data: false,
      pagination: {
        perPage: 20
      }
    };
  },
  methods: {
    getTableTypePerAggregationType() {
      switch (this.activeFilters.travel_aggregation_type) {
        case "STAY_DAY":
          return "TargetTableDataPerDay";
        case "TRAVEL_SEASON_AND_DEMAND_TYPE":
          return "TargetTableDataPerSeasonAndDemand";

        default:
          return null;
      }
    },
    loadData(filters) {
      this.data = false;
      this.activeFilters = Object.assign({}, filters);

      this.endpoints.compute(this.$root.hotelId, filters, (error, data) => {
        this.data = data;
      });
    },
    save() {
      this.endpoints.save(
        this.$root.hotelId,
        this.endpoints.create(this.data),
        (error, data) => {
          if (!error) {
            this.data = data;
            this.$root.$emit("saved");
          }
        }
      );
    }
  },
  computed: {
    paginationEntities() {
      return this.data.rows;
    }
  }
};
</script>

<style lang="scss">
.md-table.max-w-100 table {
  max-width: 100%;
  width: auto;
}
.md-table-cell.border-right {
  border-right: 1px solid #ddd;
}

.md-table-head.flex-100 .md-table-head-label {
  width: 100%;
}
.md-table-head.flex-100 .md-table-head-label .d-flex.justify-around {
  justify-content: space-around;
}

.computed-table-header {
  line-height: normal;
  .md-table-head-container {
    height: unset;
  }
  .md-table-head-label {
    height: unset;
  }
}
</style>
